import { Injectable } from '@angular/core';
import { Enabling } from '@core/models/enabling.model';
import { Procedure } from '@core/models/procedures.model';
import { WorkGroup } from '@core/models/work-unit.model';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { concatMap } from 'rxjs/operators';

import { coreActions } from '../store/core.actions';
import { coreSelectors } from '../store/core.selectors';

@Injectable()
export class StateCacheService {

  constructor(
    private store: Store
  ) { }

  getProcedure(id?: number | null): Observable<Procedure | undefined> {
    if (id) {
      return this.store.select(coreSelectors.cache.procedures.selectById, { id }).pipe(
        concatMap(procedure => {
          if (procedure) {
            return of(procedure);
          } else {
            this.store.dispatch(coreActions.cacheProcedureById({ id }));
            return this.store.select(coreSelectors.cache.procedures.selectById, { id });
          }
        }),
      );
    } else {
      return of(undefined);
    }
  }

  getWorkGroup(id?: number | null): Observable<WorkGroup | undefined> {
    if (id) {
      return this.store.select(coreSelectors.cache.workGroups.selectById, { id }).pipe(
        concatMap(wg => {
          if (wg) {
            return of(wg);
          } else {
            this.store.dispatch(coreActions.cacheWorkGroupById({ id }));
            return this.store.select(coreSelectors.cache.workGroups.selectById, { id });
          }
        }),
      );
    } else {
      return of(undefined);
    }
  }

  getEnabling(id?: number | null): Observable<Enabling | undefined> {
    if (id) {
      return this.store.select(coreSelectors.cache.enablings.selectById, { id }).pipe(
        concatMap(wg => {
          if (wg) {
            return of(wg);
          } else {
            this.store.dispatch(coreActions.cacheEnablingById({ id }));
            return this.store.select(coreSelectors.cache.enablings.selectById, { id });
          }
        }),
      );
    } else {
      return of(undefined);
    }
  }
}
